/**
 * 接口模型分类占比
 */

import { useEffect, useState } from 'react';
import $ from 'jquery';
import {
    AddRequestHeaders,
} from '../../incs/FunHelper.js';
import CNF from '../../incs/Config.js';

import RTypePercent from '../../components/RTypePercent.js';

const LogDMC = (props) => {
    const [isRefresh, setIsRefresh] = useState(true);
    const [data, setData] = useState([]);

    useEffect(() => {
        if (props.data) {
            setData(props.data);
        } else {
            if (isRefresh) {
                $.ajax({
                    url: `${CNF.api}reports/log/dmc`,
                    headers: AddRequestHeaders(),
                    crossDomain: true,
                    type: 'GET',
                    dataType: 'JSON', success: function (data) {
                        if (data.res === 0) {
                            if (data.dat.length > 0) {
                                setData(data.dat);
                            } else {
                                setData([]);
                            }
                            setIsRefresh(false);
                        }
                    }
                })
            }
        }
    }, [props, data]);

    return <RTypePercent data={data} title='接口模型分类占比' subtitle='展示各个模型的使用占比，各版本汇总，使用百分比。' />
}

export default LogDMC;